import axios from 'axios'
import platform from 'platform'
import MD5 from 'crypto-js/md5'
import CryptoJS from 'crypto-js'

import store from '../store'
import router from '../router'

import { message } from 'ant-design-vue'

import Util from './util'

const http = axios.create()

http.loading = {}

http.rids = new Set()

http.openLoading = config => {
    if (config.loading != undefined && config.loading.flag !== undefined && !config.loading.flag) {
        return
    }
    http.rids.add(config.rid)
    setTimeout(() => {
        if (http.rids.size > 0) {
            store.commit('setLoading', {
                flag: true,
                full: config.loading !== undefined && config.loading.full !== undefined ? config.loading.full : true
            })
        }
    }, 300)
}
http.hideLoading = rid => {
    if (rid === 'All') {
        http.rids.clear()
    } else {
        http.rids.delete(rid)
    }
    if (http.rids.size > 0) {
        return
    }
    setTimeout(() => {
        store.commit('setLoading', {
            flag: false,
            full: true
        })
    }, 300)
}

http.msg = msg => {
    message.destroy()
    message.error(msg)
}

http.sign = () => {
    let token = store.state.User.token || 'Guest'
    let time = new Date().getTime() + ''

    let version = 100001

    let _token = (token + Util.reverse(token)).substring(4, token.length * 2 - 4)
    let _time = parseInt(time.substring(8)) * parseInt(time.substring(6, 8)) + ''
    let _sign = MD5(_time + '|' + _token).toString()

    let sign = Util.reverse(MD5(_sign).toString()).substring(0, 8) + _sign + Util.reverse(MD5(_sign).toString()).substring(_sign.length - 8)

    return {
        Token: token,
        Time: time,
        Version: version,
        Sign: sign
    }
}

http.root = () => {
    return process.env.VUE_APP_API_ROOT
}

http.defaults.baseURL = http.root()
http.defaults.timeout = 60 * 1000
http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
http.defaults.transformRequest = [
    function(data) {
        let form = new FormData()
        for (let key in data) {
            form.append(key, data[key])
        }
        return form
    }
]

http.interceptors.request.use(
    function(config) {
        // 设置接口请求头信息
        let signInfo = http.sign()
        config.headers['X-RB-Token'] = signInfo.Token
        config.headers['X-RB-Time'] = signInfo.Time
        config.headers['X-RB-Version'] = signInfo.Version
        config.headers['X-RB-Sign'] = signInfo.Sign
        config.headers['X-RB-Client'] = platform.description

        config.rid = signInfo.Time + '' + Math.random()

        http.openLoading(config)
        return config
    },
    function(error) {
        http.hideLoading('All')
        http.msg('请求服务器失败')
        return Promise.reject(error)
    }
)

http.interceptors.response.use(
    function(response) {
        if (response.headers['content-type'].indexOf('json') >= 0) {
            if (typeof response.data == 'string' && response.data.indexOf('{') != 0) {
                let e = response.headers['E' + '-' + 'D' + 'ata'] || response.headers['e' + '-' + 'd' + 'ata']
                let decrypt = CryptoJS.AES.decrypt(CryptoJS.enc.Base64.stringify(CryptoJS.enc.Base64.parse(response.data)), CryptoJS.enc.Utf8.parse(Util.reverse(e).substring(2, 18)), {
                    iv: CryptoJS.enc.Utf8.parse(e.substring(4, 20)),
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                })
                response.data = JSON.parse(decrypt.toString(CryptoJS.enc.Utf8).toString())
            }

            if (response.data && response.data.code !== 0) {
                http.msg(response.data.info)
                if (response.data.code === 19 || response.data.code === 20) {
                    store.commit('signout')
                    router.push({
                        name: 'guest.login'
                    })
                    http.hideLoading(response.config.rid)
                    return Promise.reject(response.data)
                }
            }
        }
        http.hideLoading(response.config.rid)
        return response.data
    },
    function(error) {
        http.hideLoading(error.config.rid)
        http.msg('请求服务器失败')
        return Promise.reject(error)
    }
)

export default http
